<div class="app-company-wrapper">
  <app-company-breadcrumbs [forecast]="forecast ?? null" />
  <router-outlet></router-outlet>
</div>
